import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Steps } from 'antd'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { putSignUp, changeSignUpStep } from '../../redux-flow/actions/signup'
import CookieConsentComponent from '../../Components/CookieConsent'
import './finish.css'
import Form1 from './Form1'
import Form2 from './Form2'
import { ReactComponent as Inicio } from '../../images/tick-circle.svg'
import { ReactComponent as Check } from '../../images/tick-circle-big.svg'
import { ReactComponent as User } from '../../images/profile-circle.svg'
import { ReactComponent as Location } from '../../images/location.svg'
import { ReactComponent as Star } from '../../images/star.svg'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { Redirect } from 'react-router-dom'

const Step = Steps.Step

class Cadastro extends Component {
    constructor() {
        super();
          this.state = {
          fillBackground: false,
          step: 1
        };
      }

    componentDidMount = async () => {
        const { onLoad, userid, userLoading, userLogged, changeStep } = this.props
        if (onLoad && userid) {
            onLoad(this.props.userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentDidUpdate() {
        const { userLoading, userLogged, changeStep, currentStep } = this.props
        if(changeStep && !userLoading && currentStep === 1) {
            if(userLogged.cpf !== null) {
                if(userLogged.cep !== null) {
                    changeStep(3)
                } else {
                    changeStep(2)
                }
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    onChangeEmail = (e) => {
        this.setState({ email: e.target.value })
    }

    render() {
        const { currentStep, handleSubmit, isLoading, message, logged, nome, userLogged, userLoading, error, userid } = this.props
        return (
            !logged ? <Redirect to="/login" /> : (
            <div id="sectionContato">
            <Navbar fillBackground={this.state.fillBackground} />
                <div className="section headerWrapper cadastroWrapper pb-0">
                    <Container  className="h-100">
                        <Row className="h-100" style={{ display: currentStep < 3 ? 'flex' : 'none' }}>
                            <Col md={6} className="d-flex flex-column p-0 pr-5 finishCall">
                                <h2 className="pageCall text-white text-left mt-5">Olá, <span className="tx-pink">{nome.split(' ')[0]}</span> falta pouco para você embarcar no futuro.</h2>
                                <h4 className="text-left">
                                Mas para poder usar toda a plataforma {process.env.REACT_APP_NAME}, precisamos conhecer mais sobre você!
                                </h4>
                            </Col>
                            <Col md={6} className="p-0 pl-5 finishForm">
                                <div className="cadastroFormWrapper">
                                    <div className="contentWrapper">
                                        <div style={{ display: currentStep < 3 ? 'block' : 'none' }}>
                                            <Steps current={2} labelPlacement="vertical"  className="mb-5">
                                                <Step status="finished" title="Início" icon={<Inicio />} />
                                                <Step status={currentStep === 1 ? 'wait' : 'finished'} title="Sobre você" icon={<User />} />
                                                <Step status="wait" title="Endereço" icon={<Location />} />
                                                <Step status="wait" title="Bem vindo!" icon={<Star />} />
                                            </Steps>
                                            {currentStep === 1 ? <Form1 error={error} user={userLogged} loading={userLoading} isLoading={isLoading} handleSubmit={handleSubmit} userid={userid} /> : <Form2 error={error} isLoading={isLoading} handleSubmit={handleSubmit} userid={userid} />}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="h-100" style={{ display: currentStep === 3 ? 'flex' : 'none' }}>
                            <Col lg={12} xl={12} md={12} className="d-flex flex-column align-items-center w-100 m-0 text-center text-white">
                                    <h2 className="pageCall text-white mt-5">Cadastro Concluído</h2>
                                    <Check />
                                    <p className="textRegistro mt-5">Agora você faz parte da revolução da economia como conhecemos!</p>
                                    {/* <p className="textRegistro">Use a Carteira {process.env.REACT_APP_NAME} para comprar Bitcoin e fazer transações usando cripto!</p> */}
                                    {/* <p className="textRegistro"><a href="https://www.youtube.com/watch?v=Yx9WYNPCfGU" target="_blank" rel="noopener noreferrer">Veja tudo o que você pode fazer com a sua Carteira {process.env.REACT_APP_NAME}</a></p> */}
                                    <p className="text-inicio"><a href="/minhaconta">Seguir para tela inicial</a></p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            <CookieConsentComponent />
            <Footer />
        </div>)
        )
    }
}

const mapStateToProps = state => ({
    currentStep: state.signup.stepNumber,
    isLoading: state.signup.isLoading,
    error: state.signup.message,
    message: state.signup.logMessage,
    logged: state.login.logged,
    nome: state.login.nome,
    userLoading: state.users.isLoading,
    userLogged: state.users.userLogged,
    userid: state.login.userid,
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (form, file, step, userid) => e => {
        e.preventDefault()
        dispatch(putSignUp(form, file, step, userid))
    },
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    },
    changeStep: step => {
        dispatch(changeSignUpStep(step))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Cadastro)